import { ChangeEventHandler, FunctionComponent, MouseEventHandler } from 'react';
import Box from '../../../../components/fela/Box';
import { IStylingProps } from '../../../../themes/types';
import componentStyles from './radio-toggle-wrap-v2.style';

export interface SharedTypes {
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  block?: boolean;
}

interface PropTypes extends SharedTypes, IStylingProps {
  id: string;
  value?: string;
  name: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onClick?: MouseEventHandler<HTMLInputElement>;
  autoFocus?: boolean;
  children: JSX.Element;
}

const RadioToggleWrapV2: FunctionComponent<PropTypes> = ({
  id,
  value,
  name,
  onChange,
  onClick,
  checked,
  defaultChecked,
  disabled,
  children,
  autoFocus,
  block,
  ...restProps
}) => {
  const styles = componentStyles({
    block,
    disabled,
  });

  return (
    <Box style={styles.wrapper} {...restProps}>
      <Box
        as="input"
        type="radio"
        style={styles.input}
        {...{
          id,
          onChange,
          onClick,
          name,
          value,
          checked,
          defaultChecked,
          autoFocus,
          disabled,
        }}
      />
      <Box htmlFor={id} as="label" style={styles.label}>
        {children}
      </Box>
    </Box>
  );
};

export default RadioToggleWrapV2;
